var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var PatientImmunizationsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/patient-immunizations-row.html'),

    ui: {},

    events: {},

    templateContext: function () {
        var that = this;
        var dateAdministeredOfVaccine = that.model.get('dateAdministeredOfVaccine');
        var doseQuantityValue = that.model.get('doseQuantityValue');
        return {
            canEdit: that.canEdit,
            vaccineAdministeredDate: dateAdministeredOfVaccine != undefined && dateAdministeredOfVaccine != ''
            && !isNaN(dateAdministeredOfVaccine) && dateAdministeredOfVaccine != 0
                ? that.utils.longToDateTimeFormatted(dateAdministeredOfVaccine, "MM/DD/YYYY") : '-',
            doseQuantityValue: doseQuantityValue == 0 ? '-' : doseQuantityValue
        }
    },

    initialize: function (options) {
        var that = this;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
    },

    onRender: function () {

    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientImmunizationsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientImmunizationsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            canEdit: this.canEdit
        };
    }
});

var PatientImmunizations = Marionette.View.extend({
        template: require('../../templates/medicals/patient-immunizations.html'),

        regions: {
            body: {
                el: 'tbody',
                replaceElement: true
            }
        },

        ui: {
            sortable: '.sortable',
            updateBtn: '#update-from-grits'
        },

        events: {
            'click @ui.sortable': 'headerSorting',
            'click @ui.updateBtn': 'onUpdateFromGrits'
        },

        childViewEvents: {},

        templateContext: function () {
            var that = this;
            return {
                canEdit: that.canEdit,
                name: that.name
            }
        },

        initialize: function (options) {
            this.medProfileModel = options.medProfileModel;
            this.patient = _.omit(options.patient, "@class");
            this.name = options.name;
            this.canEdit = options.canEdit;
            this.collection = new Backbone.Collection(this.medProfileModel.get('object').immunizations);

            this.utils = new CommonUtils();
        },

        onRender: function () {
            var that = this;
            that.showChildView('body', new PatientImmunizationsTableBody({
                collection: that.collection,
                canEdit: that.canEdit
            }));

            window.setTimeout(function () {
                that.asyncImmunizationsRequests(that.collection, that.patient);
            }, 0);
        },

        asyncImmunizationsRequests: function (collection, patient) {
            var that = this;
            Constants.immunizationAddresses.forEach(function (address) {
                var url = address.url;
                var method = address.method;

                that.showLoading();
                $.ajax({
                    type: method,
                    url: url,
                    data: JSON.stringify(patient),
                    contentType: 'application/json',
                    statusCode: {
                        200: function (immnunizations) {
                            if (_.isArray(immnunizations)) {
                                var isNewExists = false;
                                immnunizations.forEach(function (immnunization) {
                                    if (that.isMedProfileNotContains(immnunization)) {
                                        collection.add(new Backbone.Model(immnunization));
                                        that.addToMedProfile(immnunization);
                                        isNewExists = true;
                                    }
                                });
                                if (isNewExists) {
                                    that.saveMedProfile();
                                }
                            }
                            that.hideLoading();
                        },
                        503: function (e) {
                            notificationsChannel.request('show:notification', e.responseJSON);
                            that.hideLoading();
                        },
                        401: function (e) {
                            actionsChannel.request("redirect:to:login");
                            that.hideLoading();
                        }
                    },
                    error: function (e) {
                        that.hideLoading();
                        console.log(e);
                    }
                });
            });
        },

        isMedProfileNotContains: function (immnunization) {
            var that = this;
            return (that.medProfileModel.get('object').immunizations || []).filter(function (immun) {
                    return _.isEqual(_.omit(immun, 'uuid'), _.omit(immnunization, 'uuid'));
                }).length == 0;
        },

        addToMedProfile: function (immnunization) {
            var that = this;
            if (that.medProfileModel.get('object').immunizations == null)
                that.medProfileModel.get('object').immunizations = [];
            that.medProfileModel.get('object').immunizations.push(immnunization);
        },

        saveMedProfile: function () {
            var that = this;

            that.medProfileModel.save(that.medProfileModel.toJSON(), {
                success: function () {
                },
                error: function (model, xhr, options) {
                    notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
                }
            });
        },

        headerSorting: function (event) {
            var sortField = event.target.id;
            var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');

            this.ui.sortable.each(function () {
                $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
                $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
            });
            if (byAsc)
                $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
            else
                $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');

            this.collection.comparator = function (model1, model2) {
                if (byAsc)
                    return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
                else
                    return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
            };
            this.collection.sort();
        },

        showLoading: function () {
            this.utils.showSpinner();
        },

        hideLoading: function () {
            this.utils.hideSpinner();
        },

        onUpdateFromGrits: function () {
            this.asyncImmunizationsRequests(this.collection, this.patient);
        }

    })
;

module.exports = PatientImmunizations;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-immunizations-view.js
// module id = 375
// module chunks = 0